import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import DynamicBottomBar from "./DynamicBottomBar";
import IconTasks from "../assets/icon_tasks.svg";
import IconRecurring from "../assets/icon_recurring.svg";
import IconSpark from "../assets/icon_spark.svg";
import IconStats from "../assets/icon_vertical_bars.svg";
import IconInvoice from "../assets/icon_invoice.svg";
import IconSettings from "../assets/icon_settings.svg";
import { SessionContext } from "../contexts/SessionContext";

const MainAppContainer = ({ children }) => {
  const navigate = useNavigate();
  const { selectBottomBarTab, bottomBarTab } = useContext(SessionContext);

  // Bottom bar mirrors Android: Tasks, Recurring, Chat, Stats, Invoice,
  // Settings. Only Tasks and Settings are wired to real screens for now; the
  // rest route to a "Coming soon" placeholder until they're built on the web.
  const menuItems = [
    {
      icon: IconTasks,
      label: "Tasks",
      onClick: () => {
        selectBottomBarTab(0);
        navigate("/home");
      },
    },
    {
      icon: IconRecurring,
      label: "Recurring",
      onClick: () => {
        selectBottomBarTab(1);
        navigate("/recurring");
      },
    },
    {
      icon: IconSpark,
      label: "Chat",
      onClick: () => {
        selectBottomBarTab(2);
        navigate("/soon/chat");
      },
    },
    {
      icon: IconStats,
      label: "Stats",
      onClick: () => {
        selectBottomBarTab(3);
        navigate("/stats");
      },
    },
    {
      icon: IconInvoice,
      label: "Invoice",
      onClick: () => {
        selectBottomBarTab(4);
        navigate("/invoice");
      },
    },
    {
      icon: IconSettings,
      label: "Settings",
      onClick: () => {
        selectBottomBarTab(5);
        navigate("/settings");
      },
    },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {children}
      </div>
      <DynamicBottomBar menuItems={menuItems} selectedTab={bottomBarTab} />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    position: "relative",
    backgroundColor: "var(--bg)",
  },
  content: {
    flex: 1,
    overflow: "auto",
    paddingBottom: "60px", // exact bottom-bar height — no dead gap above it
  },
};

export default MainAppContainer;